import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { addContentFavorite, removeContentFavorite } from '~src/favorites/actions/FavoritesActions';
import { addFieldToSortOrder } from '~src/spacesPlatform/actions/AddFieldToSortOrderAction';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { selectCatalogingOnSiteEnabled } from '../../../catalog/selectors/CatalogSelectors';
import { showContentTypes } from '../../actions/ContentExplorerFilterActions';
import {
  addToContentSelection,
  deselectAll,
  removeFromContentSelection,
  selectAll,
} from '../../actions/ContentExplorerSelectionActions';
import { updateExplorerDisplayMode, updateFilterPanelVisibility } from '../../actions/DisplaySettingsActions';
import { clearMixedContentFilters } from '../../actions/filters/FilterActions';
import { getContentDetail } from '../../actions/GetContentDetailAction';
import { requestSpaceContentNextPageWithToken,requestSpaceContentsMissingSlice } from '../../actions/RequestSpaceContentsActions';
import { selectSortOrder } from '../../actions/SelectSortOrderAction';
import {
  selectCurrentlyApplicableContentTypes,
  selectMixedContentFilterClauses,
} from '../../selectors/ContentFilterSelectors';
import { selectContentFromAppState, selectContentNextPageToken,selectMoreItemsForTokenRequest,selectSelectedContentItems } from '../../selectors/ContentSelectors';
import { selectContentSort } from '../../selectors/ContentSortSelectors';
import { selectDisplaySettings } from '../../selectors/DisplaySettingsSelectors';
import { selectSpaceInfo } from '../../selectors/SpaceInfoSelectors';
import { Explorer, ExplorerDispatchProps, ExplorerOwnProps, ExplorerStateProps } from './Explorer';

const mapStateToProps: MapStateToProps<ExplorerStateProps> = (state: AppState) => ({
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
  isSelectionBusy: state.contentExplorer.selection.isBusy,
  items: selectContentFromAppState(state),
  explorerViewMode: selectDisplaySettings(state).explorerDisplayMode,
  selectedItems: selectSelectedContentItems(state),
  showFilterPanel: selectDisplaySettings(state).showFilterPanel,
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  spaceInfo: selectSpaceInfo(state),
  mixedContentFilterMap: selectMixedContentFilterClauses(state),
  contentSort: selectContentSort(state),
  urls: siteUrlsSelector(state),
  catalogingOnSiteEnabled: state.session.info == null ? false : selectCatalogingOnSiteEnabled(state),
  contentNextPageToken: selectContentNextPageToken(state),
  moreItemsForTokenRequest: selectMoreItemsForTokenRequest(state)
});

const mapDispatchToProps: MapDispatchToProps<ExplorerDispatchProps> = (dispatch) => bindActionCreators({
  addContentFavorite: addContentFavorite,
  removeContentFavorite: removeContentFavorite,
  selectItem: addToContentSelection,
  deselectItem: removeFromContentSelection,
  clearAllSelections: deselectAll,
  selectAll: selectAll,
  filterSelected: showContentTypes,
  changeExplorerViewMode: updateExplorerDisplayMode,
  updateFilterPanelVisibility: updateFilterPanelVisibility,
  contentSortSelected: selectSortOrder,
  requestSpaceContentsMissingSlice: requestSpaceContentsMissingSlice,
  requestSpaceContentNextPageWithToken: requestSpaceContentNextPageWithToken,
  addFieldToSortOrder: addFieldToSortOrder,
  clearMixedContentFilters: clearMixedContentFilters,
  getContentDetail: getContentDetail
}, dispatch);

export const ConnectedExplorer: React.ComponentClass<ExplorerOwnProps> =
    connect(mapStateToProps, mapDispatchToProps)(Explorer);
